export default __webpack_public_path__ + "static/media/MyNatureFooterSmall.81150596.jpeg";